// import React, { useState, useCallback } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   Paper,
//   CircularProgress,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import { useDropzone } from 'react-dropzone';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const LogoContainer = styled(Box)(({ theme }) => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   [theme.breakpoints.down('sm')]: {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
//   [theme.breakpoints.down('xs')]: {
//     padding: '8px',
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px 16px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// const DropzoneBox = styled(Box)(() => ({
//   border: '2px dashed #cccccc',
//   borderRadius: '12px',
//   padding: '20px',
//   textAlign: 'center',
//   cursor: 'pointer',
//   '&:hover': {
//     borderColor: themeColors.primary,
//   },
// }));

// export default function InternshipApplication() {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     institution: '',
//     graduation_degree: '',
//     post_graduation_degree: '',
//     gender: '',
//     cover_letter: '',
//     field_of_study: '',
//     experience:'',
//     skills:'',
//     graduation_year:'',

//   });

//   const [resumeFile, setResumeFile] = useState(null);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const validate = () => {
//     const newErrors = {};
//     if (!formData.full_name.trim()) {
//       newErrors.full_name = 'Full Name is required';
//     }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }
//     if (!resumeFile) {
//       newErrors.resume = 'Resume upload is required';
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const onDrop = useCallback((acceptedFiles) => {
//     setResumeFile(acceptedFiles[0]);
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: {
//       'application/pdf': ['.pdf'],
//       'application/msword': ['.doc'],
//       'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
//     },
//     multiple: false,
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);

//     const formDataObj = new FormData();
//     Object.entries(formData).forEach(([key, value]) => {
//       formDataObj.append(key, value);
//     });
//     if (resumeFile) {
//       formDataObj.append('resume_upload', resumeFile);
//     }

//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/innovate/applicants/', {
//         method: 'POST',
//         body: formDataObj,
//       });
//       const data = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           title: 'Application Submitted!',
//           text: 'Your internship application has been successfully submitted.',
//           icon: 'success',
//           confirmButtonText: 'Okay',
//           willClose: () => navigate('/'),
//         });
//       } else {
//         Swal.fire({
//           title: 'Error!',
//           text: data.message || 'Failed to submit application.',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error!',
//         text: 'An unexpected error occurred. Please try again later.',
//         icon: 'error',
//         confirmButtonText: 'Close',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//                 Attend Innovatex and Apply for Internship

//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               experience:'Experience',
//               skills:'Skills',
//               graduation_year:'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={6} md={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Degree</InputLabel>
//                 <Select
//                   name="graduation_degree"
//                   value={formData.graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others','NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Post-Graduation Degree</InputLabel>
//                 <Select
//                   name="post_graduation_degree"
//                   value={formData.post_graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'M. Tech', 'M.Sc.', 'M. Arch', 'Others','NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ border: '1px solid #cccccc', borderRadius: '12px', padding: '5px' }}>
//                 <Typography variant="subtitle2" gutterBottom>
//                   Submit Resume
//                 </Typography>
//                 <DropzoneBox {...getRootProps()}>
//                   <input {...getInputProps()} />
//                   {isDragActive ? (
//                     <Typography>Drop the resume here ...</Typography>
//                   ) : (
//                     <Typography>Drag 'n' drop resume here</Typography>
//                   )}
//                 </DropzoneBox>
//                 {resumeFile && (
//                   <Typography variant="body2" sx={{ mt: 1 }}>
//                     File: {resumeFile.name}
//                   </Typography>
//                 )}
//                 {errors.resume && <Typography color="error">{errors.resume}</Typography>}
//               </Box>
//             </Grid>

//             <Grid item xs={12}>
//               <StyledTextField
//                 fullWidth
//                 label="Cover Letter"
//                 name="cover_letter"
//                 value={formData.cover_letter}
//                 onChange={handleChange}
//                 multiline
//                 rows={4}
//               />
//             </Grid>
//           </Grid>

//           <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 3 }}>
//             <RegisterButton type="submit" disabled={loading}>
//               {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Application'}
//             </RegisterButton>
//           </Box>
//         </form>
//       </StyledPaper>
//     </Box>
//   );
// }

// import React, { useState, useCallback } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   Paper,
//   CircularProgress,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import { useDropzone } from 'react-dropzone';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const LogoContainer = styled(Box)(({ theme }) => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   [theme.breakpoints.down('sm')]: {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
//   [theme.breakpoints.down('xs')]: {
//     padding: '8px',
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px 16px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// const DropzoneBox = styled(Box)(() => ({
//   border: '2px dashed #cccccc',
//   borderRadius: '12px',
//   padding: '20px',
//   textAlign: 'center',
//   cursor: 'pointer',
//   '&:hover': {
//     borderColor: themeColors.primary,
//   },
// }));

// export default function InternshipApplication() {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     institution: '',
//     graduation_degree: '',
//     post_graduation_degree: '',
//     gender: '',
//     cover_letter: '',
//     field_of_study: '',
//     experience: '',
//     skills: '',
//     graduation_year: '',
//   });

//   const [resumeFile, setResumeFile] = useState(null);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const validate = () => {
//     const newErrors = {};

//     if (!formData.full_name.trim()) newErrors.full_name = 'Full Name is required';
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = 'Invalid email address';
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) newErrors.phone_number = 'Phone Number must be 10 digits';
//     if (!formData.address.trim()) newErrors.address = 'Address is required';
//     if (!formData.city.trim()) newErrors.city = 'City is required';
//     if (!formData.state.trim()) newErrors.state = 'State is required';
//     if (!/^[0-9]{5,6}$/.test(formData.postal_code)) newErrors.postal_code = 'Invalid Postal Code';
//     if (!formData.country.trim()) newErrors.country = 'Country is required';
//     if (!formData.institution.trim()) newErrors.institution = 'Institution is required';
//     if (!formData.field_of_study.trim()) newErrors.field_of_study = 'Field of Study is required';
//     if (!formData.experience.trim()) newErrors.experience = 'Experience is required';
//     if (!formData.skills.trim()) newErrors.skills = 'Skills are required';
//     if (!/^(19|20)\d{2}$/.test(formData.graduation_year)) newErrors.graduation_year = 'Invalid Graduation Year';

//     if (!formData.graduation_degree) newErrors.graduation_degree = 'Graduation Degree is required';
//     if (!formData.post_graduation_degree) newErrors.post_graduation_degree = 'Post-Graduation Degree is required';
//     if (!formData.gender) newErrors.gender = 'Gender is required';
//     if (!resumeFile) newErrors.resume = 'Resume upload is required';

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const onDrop = useCallback((acceptedFiles) => {
//     setResumeFile(acceptedFiles[0]);
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: {
//       'application/pdf': ['.pdf'],
//       'application/msword': ['.doc'],
//       'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
//     },
//     multiple: false,
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//     setErrors((prevState) => ({
//       ...prevState,
//       [name]: validate(name, value),
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);

//     const formDataObj = new FormData();
//     Object.entries(formData).forEach(([key, value]) => {
//       formDataObj.append(key, value);
//     });
//     if (resumeFile) {
//       formDataObj.append('resume', resumeFile);
//     }

//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/innovate/applicants/', {
//         method: 'POST',
//         body: formDataObj,
//       });
//       const data = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           title: 'Application Submitted!',
//           text: 'Your internship application has been successfully submitted.',
//           icon: 'success',
//           confirmButtonText: 'Okay',
//           willClose: () => navigate('/'),
//         });
//       } else {
//         Swal.fire({
//           title: 'Error!',
//           text: data.message || 'Failed to submit application.',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error!',
//         text: 'An unexpected error occurred. Please try again later.',
//         icon: 'error',
//         confirmButtonText: 'Close',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           Attend Innovatex and Apply for Internship
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               experience: 'Experience',
//               skills: 'Skills',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={6} md={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Degree</InputLabel>
//                 <Select
//                   name="graduation_degree"
//                   value={formData.graduation_degree}
//                   onChange={handleChange}
//                   error={!!errors.graduation_degree}
//                 helperText={errors.graduation_degree}
                  
//                   required
//                 >
//                   {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Post-Graduation Degree</InputLabel>
//                 <Select
//                   name="post_graduation_degree"
//                   value={formData.post_graduation_degree}
//                   onChange={handleChange}
//                   error={!!errors.post_graduation_degree}
//                   helperText={errors.post_graduation_degree}
//                   required
//                 >
//                   {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'B. Tech', 'M.Sc.', 'M. Arch', 'Others'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
                  
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ border: '1px solid #cccccc', borderRadius: '12px', padding: '5px' }}>
//                 <Typography variant="subtitle2" gutterBottom>
//                   Submit Resume
//                 </Typography>
//                 <DropzoneBox {...getRootProps()}>
//                   <input {...getInputProps()} />
//                   {isDragActive ? (
//                     <Typography>Drop the resume here ...</Typography>
//                   ) : (
//                     <Typography>Drag 'n' drop resume here</Typography>
//                   )}
//                 </DropzoneBox>
//                 {resumeFile && (
//                   <Typography variant="body2" sx={{ mt: 1 }}>
//                     File: {resumeFile.name}
//                   </Typography>
//                 )}
//                 {errors.resume && <Typography color="error">{errors.resume}</Typography>}
//               </Box>
//             </Grid>

//             <Grid item xs={12}>
//               <StyledTextField
//                 fullWidth
//                 label="Cover Letter"
//                 name="cover_letter"
//                 value={formData.cover_letter}
//                 onChange={handleChange}
//                 error={!!errors.cover_letter}
//                   helperText={errors.cover_letter}
//                 multiline
//                 rows={4}
//               />
//             </Grid>
//           </Grid>

//           <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 3 }}>
//             <RegisterButton type="submit" disabled={loading}>
//               {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Application'}
//             </RegisterButton>
//           </Box>
//         </form>
//       </StyledPaper>
//     </Box>
//   );
// }

// import React, { useState, useCallback } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   Paper,
//   CircularProgress,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import { useDropzone } from 'react-dropzone';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const LogoContainer = styled(Box)(({ theme }) => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   [theme.breakpoints.down('sm')]: {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
//   [theme.breakpoints.down('xs')]: {
//     padding: '8px',
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px 16px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// const DropzoneBox = styled(Box)(() => ({
//   border: '2px dashed #cccccc',
//   borderRadius: '12px',
//   padding: '20px',
//   textAlign: 'center',
//   cursor: 'pointer',
//   '&:hover': {
//     borderColor: themeColors.primary,
//   },
// }));

// export default function InternshipApplication() {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     institution: '',
//     graduation_degree: '',
//     post_graduation_degree: '',
//     gender: '',
//     cover_letter: '',
//     field_of_study: '',
//     experience: '',
//     skills: '',
//     graduation_year: '',
//   });

//   const [resumeFile, setResumeFile] = useState(null);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const validateField = (name, value) => {
//     switch (name) {
//       case 'full_name':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'Full Name should only contain letters and spaces.';
//       case 'email':
//         return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Invalid email address.';
//       case 'phone_number':
//         return /^[0-9]{10}$/.test(value) ? '' : 'Phone Number should be exactly 10 digits.';
//       case 'address':
//         return value.trim() ? '' : 'Address is required.';
//       case 'city':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'City should only contain letters and spaces.';
//       case 'state':
//         return value.trim() ? '' : 'State is required.';
//       case 'postal_code':
//         return /^[0-9]{5,6}$/.test(value) ? '' : 'Invalid Postal Code.';
//       case 'country':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'Country should only contain letters and spaces.';
//       case 'institution':
//         return value.trim() ? '' : 'Institution is required.';
//       case 'field_of_study':
//         return value.trim() ? '' : 'Field of Study is required.';
//       case 'experience':
//         return value.trim() ? '' : 'Experience is required.';
//       case 'skills':
//         return value.trim() ? '' : 'Skills are required.';
//       case 'graduation_year':
//         return /^(19|20)\d{2}$/.test(value) ? '' : 'Invalid Graduation Year.';
//       case 'graduation_degree':
//         return value ? '' : 'Graduation Degree is required.';
//       case 'post_graduation_degree':
//         return value ? '' : 'Post-Graduation Degree is required.';
//       case 'gender':
//         return value ? '' : 'Gender is required.';
//       case 'resume':
//         return resumeFile ? '' : 'Resume upload is required.';
//       default:
//         return '';
//     }
//   };
  
//   const validate = () => {
//     const newErrors = {};
  
//     Object.entries(formData).forEach(([name, value]) => {
//       const error = validateField(name, value);
//       if (error) newErrors[name] = error;
//     });
  
//     if (!resumeFile) {
//       newErrors.resume = 'Resume upload is required.';
//     }
  
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };
  

//   const onDrop = useCallback((acceptedFiles) => {
//     setResumeFile(acceptedFiles[0]);
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: {
//       'application/pdf': ['.pdf'],
//       'application/msword': ['.doc'],
//       'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
//     },
//     multiple: false,
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//     setErrors((prevState) => ({
//       ...prevState,
//       [name]: validateField(name, value),
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);

//     const formDataObj = new FormData();
//     Object.entries(formData).forEach(([key, value]) => {
//       formDataObj.append(key, value);
//     });
//     if (resumeFile) {
//       formDataObj.append('resume', resumeFile);
//     }

//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/innovate/applicants/', {
//         method: 'POST',
//         body: formDataObj,
//       });
//       const data = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           title: 'Application Submitted!',
//           text: 'Your internship application has been successfully submitted.',
//           icon: 'success',
//           confirmButtonText: 'Okay',
//           willClose: () => navigate('/'),
//         });
//       } else {
//         Swal.fire({
//           title: 'Error!',
//           text: data.message || 'Failed to submit application.',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error!',
//         text: 'An unexpected error occurred. Please try again later.',
//         icon: 'error',
//         confirmButtonText: 'Close',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           Attend Innovatex and Apply for Internship
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               experience: 'Experience',
//               skills: 'Skills',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={6} md={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                   required
                  
//                 />
//               </Grid>
//             ))}

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Degree</InputLabel>
//                 <Select
//                   name="graduation_degree"
//                   value={formData.graduation_degree}
//                   onChange={handleChange}
//                   error={!!errors.graduation_degree}
//                   helperText={errors.graduation_degree}
                  
//                   required
//                 >
//                   {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others','N/A'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Post-Graduation Degree</InputLabel>
//                 <Select
//                   name="post_graduation_degree"
//                   value={formData.post_graduation_degree}
//                   onChange={handleChange}
//                   error={!!errors.post_graduation_degree}
//                   helperText={errors.post_graduation_degree}
//                   required
//                 >
//                   {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'M. Tech', 'M.Sc.', 'M. Arch', 'Others','N/A'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
                  
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ border: '1px solid #cccccc', borderRadius: '12px', padding: '5px' }}>
//                 <Typography variant="subtitle2" gutterBottom>
//                   Submit Resume
//                 </Typography>
//                 <DropzoneBox {...getRootProps()}>
//                   <input {...getInputProps()} />
//                   {isDragActive ? (
//                     <Typography>Drop the resume here ...</Typography>
//                   ) : (
//                     <Typography>Drag 'n' drop resume here</Typography>
//                   )}
//                 </DropzoneBox>
//                 {resumeFile && (
//                   <Typography variant="body2" sx={{ mt: 1 }}>
//                     File: {resumeFile.name}
//                   </Typography>
//                 )}
//                 {errors.resume && <Typography color="error">{errors.resume}</Typography>}
//               </Box>
//             </Grid>

//             <Grid item xs={12}>
//               <StyledTextField
//                 fullWidth
//                 label="Cover Letter"
//                 name="cover_letter"
//                 value={formData.cover_letter}
//                 onChange={handleChange}
//                 error={!!errors.cover_letter}
//                   helperText={errors.cover_letter}
//                 multiline
//                 rows={4}
//               />
//             </Grid>
//           </Grid>

//           <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 3 }}>
//             <RegisterButton type="submit" disabled={loading}>
//               {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Application'}
//             </RegisterButton>
//           </Box>
//         </form>
//       </StyledPaper>
//     </Box>
//   );
// }

// import React, { useState, useCallback } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   Paper,
//   CircularProgress,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import { useDropzone } from 'react-dropzone';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const LogoContainer = styled(Box)(({ theme }) => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   [theme.breakpoints.down('sm')]: {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
//   [theme.breakpoints.down('xs')]: {
//     padding: '8px',
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px 16px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// const DropzoneBox = styled(Box)(() => ({
//   border: '2px dashed #cccccc',
//   borderRadius: '12px',
//   padding: '20px',
//   textAlign: 'center',
//   cursor: 'pointer',
//   '&:hover': {
//     borderColor: themeColors.primary,
//   },
// }));

// export default function InternshipApplication() {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     institution: '',
//     graduation_degree: '',
//     post_graduation_degree: '',
//     gender: '',
//     cover_letter: '',
//     field_of_study: '',
//     experience: '',
//     skills: '',
//     graduation_year: '',
//   });

//   const [resumeFile, setResumeFile] = useState(null);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const validateField = (name, value) => {
//     switch (name) {
//       case 'full_name':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'Full Name should only contain letters and spaces.';
//       case 'email':
//         return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Invalid email address.';
//       case 'phone_number':
//         return /^[0-9]{10}$/.test(value) ? '' : 'Phone Number should be exactly 10 digits.';
//       case 'address':
//         return value.trim() ? '' : 'Address is required.';
//       case 'city':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'City should only contain letters and spaces.';
//       case 'state':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'State should only contain letters and spaces.';
//       case 'postal_code':
//         return /^[0-9]{5,6}$/.test(value) ? '' : 'Invalid Postal Code.';
//       case 'country':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'Country should only contain letters and spaces.';
//       case 'institution':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'Institution should only contain letters and spaces.';
//       case 'field_of_study':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'Field of Study should only contain letters and spaces.';
//       case 'experience':
//         return /^[0-9]+$/.test(value) ? '' : 'Experience should only contain numbers.';
//       case 'skills':
//         return value.trim() ? '' : 'Skills are required.';
//       case 'graduation_year':
//         return /^(19|20)\d{2}$/.test(value) ? '' : 'Invalid Graduation Year.';
//       case 'graduation_degree':
//         return value ? '' : 'Graduation Degree is required.';
//       case 'post_graduation_degree':
//         return value ? '' : 'Post-Graduation Degree is required.';
//       case 'gender':
//         return value ? '' : 'Gender is required.';
//       case 'resume':
//         return resumeFile ? '' : 'Resume upload is required.';
//       default:
//         return '';
//     }
//   };

//   const validate = () => {
//     const newErrors = {};

//     Object.entries(formData).forEach(([name, value]) => {
//       const error = validateField(name, value);
//       if (error) newErrors[name] = error;
//     });

//     if (!resumeFile) {
//       newErrors.resume = 'Resume upload is required.';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const onDrop = useCallback((acceptedFiles) => {
//     setResumeFile(acceptedFiles[0]);
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: {
//       'application/pdf': ['.pdf'],
//       'application/msword': ['.doc'],
//       'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
//     },
//     multiple: false,
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//     setErrors((prevState) => ({
//       ...prevState,
//       [name]: validateField(name, value),
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);

//     const formDataObj = new FormData();
//     Object.entries(formData).forEach(([key, value]) => {
//       formDataObj.append(key, value);
//     });
//     if (resumeFile) {
//       formDataObj.append('resume', resumeFile);
//     }

//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/innovate/applicants/', {
//         method: 'POST',
//         body: formDataObj,
//       });
//       const data = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           title: 'Application Submitted!',
//           text: 'Your internship application has been successfully submitted.',
//           icon: 'success',
//           confirmButtonText: 'Okay',
//           willClose: () => navigate('/'),
//         });
//       } else {
//         Swal.fire({
//           title: 'Error!',
//           text: data.message || 'Failed to submit application.',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error!',
//         text: 'An unexpected error occurred. Please try again later.',
//         icon: 'error',
//         confirmButtonText: 'Close',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           Attend Innovatex and Apply for Internship
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               experience: 'Experience',
//               skills: 'Skills',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={6} md={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                   required
                  
//                 />
//               </Grid>
//             ))}

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Degree</InputLabel>
//                 <Select
//                   name="graduation_degree"
//                   value={formData.graduation_degree}
//                   onChange={handleChange}
//                   error={!!errors.graduation_degree}
//                   helperText={errors.graduation_degree}
                  
//                   required
//                 >
//                   {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Post-Graduation Degree</InputLabel>
//                 <Select
//                   name="post_graduation_degree"
//                   value={formData.post_graduation_degree}
//                   onChange={handleChange}
//                   error={!!errors.post_graduation_degree}
//                   helperText={errors.post_graduation_degree}
//                   required
//                 >
//                   {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'B. Tech', 'M.Sc.', 'M. Arch', 'Others'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
                  
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ border: '1px solid #cccccc', borderRadius: '12px', padding: '5px' }}>
//                 <Typography variant="subtitle2" gutterBottom>
//                   Submit Resume
//                 </Typography>
//                 <DropzoneBox {...getRootProps()}>
//                   <input {...getInputProps()} />
//                   {isDragActive ? (
//                     <Typography>Drop the resume here ...</Typography>
//                   ) : (
//                     <Typography>Drag 'n' drop resume here</Typography>
//                   )}
//                 </DropzoneBox>
//                 {resumeFile && (
//                   <Typography variant="body2" sx={{ mt: 1 }}>
//                     File: {resumeFile.name}
//                   </Typography>
//                 )}
//                 {errors.resume && <Typography color="error">{errors.resume}</Typography>}
//               </Box>
//             </Grid>

//             <Grid item xs={12}>
//               <StyledTextField
//                 fullWidth
//                 label="Cover Letter"
//                 name="cover_letter"
//                 value={formData.cover_letter}
//                 onChange={handleChange}
//                 error={!!errors.cover_letter}
//                   helperText={errors.cover_letter}
//                 multiline
//                 rows={4}
//               />
//             </Grid>
//           </Grid>

//           <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 3 }}>
//             <RegisterButton type="submit" disabled={loading}>
//               {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Application'}
//             </RegisterButton>
//           </Box>
//         </form>
//       </StyledPaper>
//     </Box>
//   );
// }

import React, { useState, useCallback } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
  Paper,
  CircularProgress,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useDropzone } from 'react-dropzone';
import Logo1 from '../../src/landpageimage/logo1.png';
import Logo2 from '../../src/landpageimage/TDTLLogo.png';
import Logo3 from '../../src/landpageimage/logo2.jpg';
import Logo4 from '../landpageimage1/DYPLogo.png';

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '16px',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  padding: '16px 0',
  marginBottom: '16px',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));

const LogoImage = styled('img')(() => ({
  maxWidth: '100px',
  maxHeight: '80px',
  objectFit: 'contain',
  margin: '0 auto',
}));

const themeColors = {
  primary: '#2196F3',
  gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
  background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '90%',
  maxWidth: '1200px',
  margin: '0 auto',
  borderRadius: '24px',
  padding: '16px',
  backgroundColor: '#FFFFFF',
  boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
  [theme.breakpoints.down('xs')]: {
    padding: '8px',
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: '#F3F4F6',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
    '&.Mui-focused fieldset': {
      borderColor: themeColors.primary,
    },
  },
}));

const RegisterButton = styled(Button)(() => ({
  background: themeColors.gradient,
  color: 'white',
  padding: '8px 16px',
  borderRadius: '16px',
  fontWeight: 600,
  '&:hover': {
    background: '#1E88E5',
  },
}));

const DropzoneBox = styled(Box)(() => ({
  border: '2px dashed #cccccc',
  borderRadius: '12px',
  padding: '20px',
  textAlign: 'center',
  cursor: 'pointer',
  '&:hover': {
    borderColor: themeColors.primary,
  },
}));

export default function InternshipApplication() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone_number: '',
    address: '',
    city: '',
    state: '',
    postal_code: '',
    country: '',
    institution: '',
    graduation_degree: '',
    post_graduation_degree: '',
    gender: '',
    cover_letter: '',
    field_of_study: '',
    experience: '',
    skills: '',
    graduation_year: '',
  });

  const [resumeFile, setResumeFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateField = (name, value) => {
    switch (name) {
      case 'full_name':
        return /^[a-zA-Z ]+$/.test(value) ? '' : 'Full Name should only contain letters and spaces.';
      case 'email':
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Invalid email address.';
      case 'phone_number':
        return /^[0-9]{10}$/.test(value) ? '' : 'Phone Number should be exactly 10 digits.';
      case 'address':
        return value.trim() ? '' : 'Address is required.';
      case 'city':
        return /^[a-zA-Z ]+$/.test(value) ? '' : 'City should only contain letters and spaces.';
      case 'state':
        return value.trim() ? '' : 'State is required.';
      case 'postal_code':
        return /^[0-9]{5,6}$/.test(value) ? '' : 'Invalid Postal Code.';
      case 'country':
        return /^[a-zA-Z ]+$/.test(value) ? '' : 'Country should only contain letters and spaces.';
      case 'institution':
        return value.trim() ? '' : 'Institution is required.';
      case 'field_of_study':
        return value.trim() ? '' : 'Field of Study is required.';
      case 'experience':
        return value.trim() ? '' : 'Experience is required.';
      case 'skills':
        return value.trim() ? '' : 'Skills are required.';
      case 'graduation_year':
        return /^(19|20)\d{2}$/.test(value) ? '' : 'Invalid Graduation Year.';
      case 'graduation_degree':
        return value ? '' : 'Graduation Degree is required.';
      case 'post_graduation_degree':
        return value ? '' : 'Post-Graduation Degree is required.';
      case 'gender':
        return value ? '' : 'Gender is required.';
      case 'resume':
        return resumeFile ? '' : 'Resume upload is required.';
      default:
        return '';
    }
  };
  
  const validate = () => {
    const newErrors = {};
  
    Object.entries(formData).forEach(([name, value]) => {
      const error = validateField(name, value);
      if (error) newErrors[name] = error;
    });
  
    if (!resumeFile) {
      newErrors.resume = 'Resume upload is required.';
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  

  const onDrop = useCallback((acceptedFiles) => {
    setResumeFile(acceptedFiles[0]);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    multiple: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevState) => ({
      ...prevState,
      [name]: validateField(name, value),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    const formDataObj = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataObj.append(key, value);
    });
    if (resumeFile) {
      formDataObj.append('resume_upload', resumeFile);
    }

    try {
      const response = await fetch('https://newbackend.elephant-tank.com/innovate/applicants/', {
        method: 'POST',
        body: formDataObj,
      });
      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          title: 'Application Submitted!',
          text: 'Your internship application has been successfully submitted.',
          icon: 'success',
          confirmButtonText: 'Okay',
          willClose: () => navigate('/'),
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: data.message || 'Failed to submit application.',
          icon: 'error',
          confirmButtonText: 'Try Again',
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'An unexpected error occurred. Please try again later.',
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: themeColors.background,
        padding: '16px',
      }}
    >
      <StyledPaper>
        <LogoContainer>
          <LogoImage src={Logo1} alt="Logo 1" />
          <LogoImage src={Logo2} alt="Logo 2" />
          <LogoImage src={Logo3} alt="Logo 3" />
          <LogoImage src={Logo4} alt="Logo 4" />
        </LogoContainer>
        <Typography
          variant="h5"
          fontWeight="bold"
          mb={3}
          sx={{
            color: 'transparent',
            backgroundImage: themeColors.gradient,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            textAlign: 'center',
            fontSize: '1.5rem',
          }}
        >
          Attend Innovatex and Apply for Internship
        </Typography>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <Grid container spacing={2}>
            {Object.entries({
              full_name: 'Full Name',
              email: 'Email',
              phone_number: 'Phone Number',
              address: 'Address',
              city: 'City',
              state: 'State',
              postal_code: 'Postal Code',
              country: 'Country',
              institution: 'Institution',
              field_of_study: 'Field of Study',
              experience: 'Experience',
              skills: 'Skills',
              graduation_year: 'Graduation Year',
            }).map(([name, label]) => (
              <Grid item xs={12} sm={6} md={4} key={name}>
                <StyledTextField
                  fullWidth
                  label={label}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  error={!!errors[name]}
                  helperText={errors[name]}
                  required
                  
                />
              </Grid>
            ))}

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Graduation Degree</InputLabel>
                <Select
                  name="graduation_degree"
                  value={formData.graduation_degree}
                  onChange={handleChange}
                  error={!!errors.graduation_degree}
                  helperText={errors.graduation_degree}
                  
                  required
                >
                  {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others'].map((degree) => (
                    <MenuItem key={degree} value={degree}>
                      {degree}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Post-Graduation Degree</InputLabel>
                <Select
                  name="post_graduation_degree"
                  value={formData.post_graduation_degree}
                  onChange={handleChange}
                  error={!!errors.post_graduation_degree}
                  helperText={errors.post_graduation_degree}
                  required
                >
                  {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'B. Tech', 'M.Sc.', 'M. Arch', 'Others'].map((degree) => (
                    <MenuItem key={degree} value={degree}>
                      {degree}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Gender</InputLabel>
                <Select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  
                  required
                >
                  <MenuItem value="M">Male</MenuItem>
                  <MenuItem value="F">Female</MenuItem>
                  <MenuItem value="O">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Box sx={{ border: '1px solid #cccccc', borderRadius: '12px', padding: '5px' }}>
                <Typography variant="subtitle2" gutterBottom>
                  Submit Resume
                </Typography>
                <DropzoneBox {...getRootProps()}>
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <Typography>Drop the resume here ...</Typography>
                  ) : (
                    <Typography>Drag 'n' drop resume here</Typography>
                  )}
                </DropzoneBox>
                {resumeFile && (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    File: {resumeFile.name}
                  </Typography>
                )}
                {errors.resume && <Typography color="error">{errors.resume}</Typography>}
              </Box>
            </Grid>

            <Grid item xs={12}>
              <StyledTextField
                fullWidth
                label="Cover Letter"
                name="cover_letter"
                value={formData.cover_letter}
                onChange={handleChange}
                error={!!errors.cover_letter}
                  helperText={errors.cover_letter}
                multiline
                rows={4}
              />
            </Grid>
          </Grid>

          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 3 }}>
            <RegisterButton type="submit" disabled={loading}>
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Application'}
            </RegisterButton>
          </Box>
        </form>
      </StyledPaper>
    </Box>
  );
}